<div class="register-login-dialog-container">
  <mat-toolbar role="toolbar" class="gb-dialog-header">
    <h2 mat-dialog-title translate="AUTH.DIALOG.HEADER"></h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon mat-list-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <p translate="AUTH.DIALOG.SUB_HEADER"></p>
  <div class="buttons-container flex-col-center px-gap-20">
    <button
      mat-raised-button
      (click)="emitRegister()"
      color="primary"
      class="full-width-button action-button"
      translate="AUTH.DIALOG.BUTTON.REGISTER"
    ></button>

    <button
      mat-stroked-button
      (click)="emitLogin()"
      class="full-width-button"
      translate="AUTH.DIALOG.BUTTON.LOG_IN"
    ></button>
  </div>
</div>
